import * as React from "react";
interface SvgComponentProps {
	[key: string]: any;
}
const CancelIcon: React.FC<SvgComponentProps> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={17}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="m4.266 13.417-.933-.934L7.066 8.75 3.333 5.017l.933-.934L8 7.817l3.733-3.734.933.934L8.933 8.75l3.733 3.733-.933.934L8 9.683l-3.734 3.734Z"
		/>
	</svg>
);
export default CancelIcon;
